
export const FETCH_INFORMATION_REQUEST = 'FETCH_INFORMATION_REQUEST'
export const FETCH_INFORMATION_SUCCES = 'FETCH_INFORMATION_SUCCES'
export const FETCH_INFORMATION_ERROR = 'FETCH_INFORMATION_ERROR'



// WEBPACK FOOTER //
// ./src/constants/Information.js